var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEur = function SvgEur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0284C7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.28 17.5c1.043-3.613 4.295-6.25 8.147-6.25h2.428c.672 0 1.215.559 1.215 1.25s-.543 1.25-1.215 1.25h-2.428c-2.49 0-4.63 1.543-5.567 3.75h4.96c.504 0 .91.418.91.938a.92.92 0 0 1-.91.937h-5.434a6.5 6.5 0 0 0 0 1.25h5.434c.504 0 .91.418.91.938a.92.92 0 0 1-.91.937h-4.96c.937 2.207 3.078 3.75 5.567 3.75h2.428c.672 0 1.215.559 1.215 1.25s-.543 1.25-1.215 1.25h-2.428c-3.852 0-7.104-2.637-8.147-6.25h-1.264a.92.92 0 0 1-.91-.938c0-.519.405-.937.91-.937h.934a10 10 0 0 1 0-1.25h-.934a.92.92 0 0 1-.91-.938c0-.519.405-.937.91-.937z"
  })));
};
export default SvgEur;